import { useEffect } from 'react';
import { useTheme } from '@material-ui/core';
import { BackstageTheme } from '@backstage/theme';

const STYLE_ID = 'mermaid-dark-fix';

const DARK_FIX_CSS = `
  .mermaid svg [fill="#444444"] { fill: var(--arla-text-primary-color); }
  .mermaid svg [stroke="#444444"] { stroke: var(--arla-text-primary-color); }
`;

export const MermaidStyleFix = () => {
  const theme = useTheme<BackstageTheme>();
  const isDark = theme.palette.type === 'dark';

  useEffect(() => {
    const apply = () => {
      document.querySelectorAll('*').forEach(el => {
        const root = el.shadowRoot;
        if (!root) return;

        root.querySelector(`#${STYLE_ID}`)?.remove();

        if (!isDark) return;
        if (!root.querySelector('.mermaid')) return;
        if (root.querySelector(`#${STYLE_ID}`)) return;

        const style = document.createElement('style');
        style.id = STYLE_ID;
        style.textContent = DARK_FIX_CSS;
        root.appendChild(style);
      });
    };

    const observer = new MutationObserver(apply);
    observer.observe(document.body, { childList: true, subtree: true });
    apply();

    return () => observer.disconnect();
  }, [isDark]);

  return null;
};